import React from "react";
import CommonButton from "../../../components/buttons/CommonButton";
import {
  handleChange,
  handleChangeNameValue,
} from "../../../helpers/handleFormChanges";
import CommonRadioOpcoes from "../../../components/forms/CommonRadioOpcoes";
import CommonSelect from "../../../components/forms/CommonSelect";
import TabPane from "../../../components/Tab/TabPane";
import CommonSwal from "../../../components/Swal/commonSwal.jsx";
import CommonInputDecimal from "../../../components/forms/CommonInputDecimal";
import TabHelper from "../../../helpers/TabHelper.js";
import { AppContext } from "../../../contexts/AppContext.jsx";
import PropTypes from "prop-types";

function TributacaoTab({
  tabAtualHook,
  valuesHook,
  servicos,
  atividades,
  tributacaoConfig,
  modalTog,
  dadosNota,
  emitirNota,
  lucroSimples,
}) {
  const { values, setValues } = valuesHook;
  const { tabAtual, setTabAtual } = tabAtualHook;
  const { session } = React.useContext(AppContext);

  return (
    <TabPane id="tributacaoTab">
      {servicos ? (
        <div className="row mb-3">
          <div className="col-12">
            <CommonSelect
              label="Item de serviço"
              id="itemServico"
              value={values.itemServico}
              onChange={(e) => {
                const opcaoSelecionada =
                  e.target.options[e.target.selectedIndex];
                const itemServico = e.target.value;
                const aliquota = opcaoSelecionada?.dataset?.aliquota;

                setValues((prevValues) => ({
                  ...prevValues,
                  itemServico,
                  aliquota,
                }));
              }}
              data={
                servicos &&
                Object.keys(servicos).map((servicosKey) => ({
                  text: servicos[servicosKey].descricao,
                  id: servicos[servicosKey].codigo,
                  "data-aliquota": servicos[servicosKey].aliquota,
                }))
              }
              placeholder="Selecione o serviço"
              required
              disabled={Object.keys(servicos).length > 1 ? false : true}
            />
          </div>
        </div>
      ) : null}
      {values.itemServico &&
      atividades &&
      Object.keys(atividades).length > 0 ? (
        <div className="row mb-3">
          <div className="col-12">
            <CommonSelect
              label="Atividade no município"
              id="atividadeMunicipio"
              value={values.atividadeMunicipio}
              onChange={(e) => {
                handleChange(e, values, setValues);
              }}
              data={
                atividades &&
                Object.keys(atividades).map((atividadesKey) => ({
                  text: atividades[atividadesKey].descricao,
                  id: atividades[atividadesKey].codigo_atividade_municipio,
                }))
              }
              placeholder="Selecione o serviço"
              required
              disabled={Object.keys(atividades).length > 1 ? false : true}
            />
          </div>
        </div>
      ) : null}

      {dadosNota?.cnpj &&
      dadosNota?.uid !== "GLOBAL" &&
      dadosNota?.cnpj.length !== 11 ? (
        <div className="row mb-3 align-items-center">
          {tributacaoConfig && tributacaoConfig?.retencao ? (
            <div className="col-6 col-xl-3">
              <CommonRadioOpcoes
                label="ISS retido"
                id="issRetido"
                upValue={!values.issRetido}
                lowValue={values.issRetido}
                upOnChange={(e) => {
                  if (!values?.itemServico)
                    return CommonSwal({
                      title:
                        "Não é possível marcar essa opção sem selecionar um item de serviço.",
                    });

                  handleChangeNameValue(
                    "issRetido",
                    !e.target.checked,
                    values,
                    setValues
                  );
                }}
                lowOnChange={(e) => {
                  if (!values?.itemServico)
                    return CommonSwal({
                      title:
                        "Não é possível marcar essa opção sem selecionar um item de serviço.",
                    });

                  handleChangeNameValue(
                    "issRetido",
                    e.target.checked,
                    values,
                    setValues
                  );
                }}
                upText={
                  <>
                    Não{" "}
                    {!tributacaoConfig?.recomendaRetencao ? (
                      <span
                        className="badge bg-info"
                        title="Por gentileza, consulte o tomador do serviço, uma vez que ele pode optar por retenções diferentes das recomendadas."
                      >
                        Recomendado
                      </span>
                    ) : (
                      ""
                    )}
                  </>
                }
                lowText={
                  <>
                    Sim{" "}
                    {tributacaoConfig?.recomendaRetencao ? (
                      <span
                        className="badge bg-info"
                        title="Por gentileza, consulte o tomador do serviço, uma vez que ele pode optar por retenções diferentes das recomendadas."
                      >
                        Recomendado
                      </span>
                    ) : (
                      ""
                    )}
                  </>
                }
              />
            </div>
          ) : null}
          {tributacaoConfig &&
          tributacaoConfig?.deducoes &&
          session.tipo_empresa !== "2" ? (
            <div className="col-6 col-xl-3">
              <CommonRadioOpcoes
                label="Retenções federais"
                id="deducoes"
                upValue={!values.deducoes}
                lowValue={values.deducoes}
                upOnChange={(e) =>
                  handleChangeNameValue(
                    "deducoes",
                    !e.target.checked,
                    values,
                    setValues
                  )
                }
                lowOnChange={(e) =>
                  handleChangeNameValue(
                    "deducoes",
                    e.target.checked,
                    values,
                    setValues
                  )
                }
                upText={
                  <>
                    Não{" "}
                    {!tributacaoConfig?.recomendaDeducoes ? (
                      <span
                        className="badge bg-info"
                        title="Por gentileza, consulte o tomador do serviço, uma vez que ele pode optar por retenções diferentes das recomendadas."
                      >
                        Recomendado
                      </span>
                    ) : (
                      ""
                    )}
                  </>
                }
                lowText={
                  <>
                    Sim{" "}
                    {tributacaoConfig?.recomendaDeducoes ? (
                      <span
                        className="badge bg-info"
                        title="Por gentileza, consulte o tomador do serviço, uma vez que ele pode optar por retenções diferentes das recomendadas."
                      >
                        Recomendado
                      </span>
                    ) : (
                      ""
                    )}
                  </>
                }
              />
            </div>
          ) : null}
          {tributacaoConfig && tributacaoConfig?.retencaoInss ? (
            <div className="col-6 col-xl-3">
              <CommonRadioOpcoes
                label="INSS retido"
                id="inssRetido"
                upValue={!values.inssRetido}
                lowValue={values.inssRetido}
                upOnChange={(e) =>
                  handleChangeNameValue(
                    "inssRetido",
                    !e.target.checked,
                    values,
                    setValues
                  )
                }
                lowOnChange={(e) =>
                  handleChangeNameValue(
                    "inssRetido",
                    e.target.checked,
                    values,
                    setValues
                  )
                }
                upText={
                  <>
                    Não{" "}
                    {!tributacaoConfig?.recomendaRetencaoInss ? (
                      <span
                        className="badge bg-info"
                        title="Por gentileza, consulte o tomador do serviço, uma vez que ele pode optar por retenções diferentes das recomendadas."
                      >
                        Recomendado
                      </span>
                    ) : (
                      ""
                    )}
                  </>
                }
                lowText={
                  <>
                    Sim{" "}
                    {tributacaoConfig?.recomendaRetencaoInss ? (
                      <span
                        className="badge bg-info"
                        title="Por gentileza, consulte o tomador do serviço, uma vez que ele pode optar por retenções diferentes das recomendadas."
                      >
                        Recomendado
                      </span>
                    ) : (
                      ""
                    )}
                  </>
                }
              />
            </div>
          ) : null}
          {tributacaoConfig && tributacaoConfig?.alteraMunicipio ? (
            <div className="col-6 col-xl-3">
              <CommonButton onClick={modalTog} color="warning" small={true}>
                Alterar município
              </CommonButton>
            </div>
          ) : null}
        </div>
      ) : null}

      <div className="row mb-3">
        {values.issRetido ? (
          <div className="col-6 col-sm-4 col-xl-2">
            <CommonInputDecimal
              label={
                <>
                  ISS{" "}
                  <span className="badge bg-info">
                    {values?.aliquota ? values?.aliquota : 0}%
                  </span>
                </>
              }
              id="iss"
              value={values.iss}
              onChange={(value) => {
                handleChangeNameValue(
                  "iss",
                  value.floatValue,
                  values,
                  setValues
                );
              }}
              disabled
            />
          </div>
        ) : null}
        {values.deducoes ? (
          <>
            <div className="col-6 col-sm-4 col-xl-2">
              <CommonInputDecimal
                label={
                  <>
                    IRRF <span className="badge bg-info">1,5%</span>
                  </>
                }
                id="irrf"
                value={values.irrf}
                onChange={(value) => {
                  handleChangeNameValue(
                    "irrf",
                    value.floatValue,
                    values,
                    setValues
                  );
                }}
                disabled
              />
            </div>
            {!lucroSimples ? (
              <>
                <div className="col-6 col-sm-4 col-xl-2">
                  <CommonInputDecimal
                    label={
                      <>
                        PIS <span className="badge bg-info">0,65%</span>
                      </>
                    }
                    id="pis"
                    value={values.pis}
                    onChange={(value) => {
                      handleChangeNameValue(
                        "pis",
                        value.floatValue,
                        values,
                        setValues
                      );
                    }}
                    disabled
                  />
                </div>
                <div className="col-6 col-sm-4 col-xl-2">
                  <CommonInputDecimal
                    label={
                      <>
                        COFINS <span className="badge bg-info">3%</span>
                      </>
                    }
                    id="cofins"
                    value={values.cofins}
                    onChange={(value) => {
                      handleChangeNameValue(
                        "cofins",
                        value.floatValue,
                        values,
                        setValues
                      );
                    }}
                    disabled
                  />
                </div>
                <div className="col-6 col-sm-4 col-xl-2">
                  <CommonInputDecimal
                    label={
                      <>
                        CSLL <span className="badge bg-info">1%</span>
                      </>
                    }
                    id="csll"
                    value={values.csll}
                    onChange={(value) => {
                      handleChangeNameValue(
                        "csll",
                        value.floatValue,
                        values,
                        setValues
                      );
                    }}
                    disabled
                  />
                </div>
              </>
            ) : null}
          </>
        ) : null}
        {values.inssRetido ? (
          <div className="col-6 col-sm-4 col-xl-2">
            <CommonInputDecimal
              label={
                <>
                  INSS <span className="badge bg-info">11%</span>
                </>
              }
              id="inss"
              value={values.inss}
              onChange={(value) => {
                handleChangeNameValue(
                  "inss",
                  value.floatValue,
                  values,
                  setValues
                );
              }}
              disabled
            />
          </div>
        ) : null}
      </div>

      <div className="row mb-3 mx-0 gap-3 justify-content-between">
        <CommonButton
          onClick={() => {
            TabHelper.trocarTab(tabAtual, setTabAtual, -1);
          }}
          color="primary"
        >
          Anterior
        </CommonButton>
        {dadosNota?.razao_social &&
        dadosNota?.descricaoServicoPrestado &&
        dadosNota?.totalNota &&
        dadosNota?.aliquota &&
        dadosNota?.cidadeIncidencia &&
        (Object.keys(atividades).length < 1 || dadosNota.atividadeMunicipio) ? (
          <CommonButton
            style={{
              paddingRight: "1.5rem",
              paddingLeft: "1.5rem",
            }}
            color="success"
            onClick={emitirNota}
          >
            Emitir
          </CommonButton>
        ) : null}
      </div>
    </TabPane>
  );
}

TributacaoTab.propTypes = {
  tabAtualHook: PropTypes.shape({
    tabAtual: PropTypes.number.isRequired,
    setTabAtual: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  servicos: PropTypes.object,
  atividades: PropTypes.object,
  tributacaoConfig: PropTypes.object.isRequired,
  modalTog: PropTypes.func.isRequired,
  dadosNota: PropTypes.object.isRequired,
  emitirNota: PropTypes.func.isRequired,
  lucroSimples: PropTypes.bool.isRequired,
};

export default TributacaoTab;
